// extracted by mini-css-extract-plugin
export default {"checkboxSwitch":"WQB6qVamFzHL6riEOR47kQ==","checkboxSwitchLabel":"HDcv48luqI-2t1ZkKmXY2w==","checkboxSwitchLabelSecondary":"SrIDhPkFXTfTGfiko2M4ag=="};